import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PslfFieldSchema = withDefaults({
  type: 'pslf-field',
  fields: [
    {
      kind: 'attribute',
      name: 'page',
    },
    {
      kind: 'attribute',
      name: 'fieldType',
    },
    {
      kind: 'attribute',
      name: 'label',
    },
    {
      kind: 'attribute',
      name: 'x',
    },
    {
      kind: 'attribute',
      name: 'y',
    },
    {
      kind: 'attribute',
      name: 'width',
    },
    {
      kind: 'attribute',
      name: 'height',
    },
    {
      kind: 'attribute',
      name: 'key',
    },
    {
      kind: 'attribute',
      name: 'value',
    },
    {
      kind: 'attribute',
      name: 'defaultValue',
    },
    {
      kind: 'attribute',
      name: 'required',
    },
    {
      kind: 'belongsTo',
      name: 'pslfTemplate',
      type: 'pslf-template',
      options: {
        async: false,
        inverse: 'pslfFields',
      },
    },
  ],
});

export default PslfFieldSchema;
